<!-- *ngIf="(messages$ | async as messages) && messages.length" -->
<div class="vs-global-message" *ngIf="messages$ | async as messages">
  <div class="alert alert-success" *ngFor=" let confMsg of messages[messageType.MSG_TYPE_CONFIRMATION]; let i = index ">
    <div class="icon-container float-left"></div>
    <div class="message-container float-left">
      <span class="message-header">{{ "sharedComponents.success" | cxTranslate }}</span>
      <span class="message-content" [innerHtml]="confMsg | cxTranslate"></span>
    </div>
    <button class="close" type="button" (click)="clear(messageType.MSG_TYPE_CONFIRMATION, i)">
      <i class='material-icons'>
        close
      </i>
    </button>
  </div>
  <div class="alert alert-info" *ngFor="let infoMsg of messages[messageType.MSG_TYPE_INFO]; let i = index">
    <div class="icon-container float-left"></div>
    <div class="message-container float-left">
      <span class="message-header">{{ "sharedComponents.info" | cxTranslate }}</span>
      <span class="message-content" [innerHtml]="infoMsg | cxTranslate"></span>
    </div>
    <button class="close" type="button" (click)="clear(messageType.MSG_TYPE_INFO, i)">
      <i class='material-icons'>
        close
      </i>
    </button>
  </div>
  <div class="alert alert-warning" *ngFor="let warnMsg of messages[messageType.MSG_TYPE_WARNING]; let i = index">
    <div class="icon-container float-left"></div>
    <div class="message-container float-left">
      <span class="message-header">{{ "sharedComponents.warning" | cxTranslate }}</span>
      <span class="message-content" [innerHtml]="warnMsg | cxTranslate"></span>
    </div>
    <button class="close" type="button" (click)="clear(messageType.MSG_TYPE_WARNING, i)">
      <i class='material-icons'>
        close
      </i>
    </button>
  </div>
  <ng-container *ngFor="let errorMsg of messages[messageType.MSG_TYPE_ERROR]; let i = index">
    <ng-container *ngIf="errorMsg['key'] !== 'httpHandlers.unauthorized.common'">
      <div class="alert alert-danger">
        <div class="icon-container float-left"></div>
        <div class="message-container float-left">
          <span class="message-header">{{ "sharedComponents.error" | cxTranslate }}</span>
          <span class="message-content" [innerHtml]="errorMsg | cxTranslate"></span>
        </div>
        <button class="close" type="button" (click)="clear(messageType.MSG_TYPE_ERROR, i)">
          <i class='material-icons'>
            close
          </i>
        </button>
      </div>
    </ng-container>
  </ng-container>
</div>